"use client";
import axios from "axios";
import {
  getCookies,
  handleStoreCookie,
  removeAllCookies,
} from "../helpers/storage";
import { ROUTES } from "../constants/routes";
import { toastError } from "../components/toast";
import { MESSAGE } from "../constants";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Create an Axios instance
const api = axios.create({
  baseURL: BASE_URL, // Replace with your actual API base URL
});

// Function to get new access token using the refresh token
const refreshAccessToken = async (): Promise<string> => {
  const refreshToken = getCookies("refreshToken") || "";
  if (!refreshToken) redirectToLogin();
  try {
    const response = await axios.post(`${BASE_URL}/auth/token/refresh`, {
      refreshToken,
    });
    const { access_token } = response.data?.data || {};
    handleStoreCookie(access_token, refreshToken);
    return access_token;
  } catch (error) {
    console.error("Error refreshing access token:", error);
    throw error;
  }
};

const redirectToLogin = () => {
  window.location.href = ROUTES.AUTH_PHONE_NUMBER;
};

// Request interceptor to add access token to headers
api.interceptors.request.use(
  async (config) => {
    if (config.headers?.["No-Auth"]) {
      return config;
    }

    let accessToken = getCookies("accessToken");

    if (!accessToken) redirectToLogin();

    if (accessToken) {
      const tokenExpirationTime = getCookies("tokenExpirationTime");
      const isTokenExpired = new Date().getTime() > Number(tokenExpirationTime);

      if (isTokenExpired) {
        accessToken = await refreshAccessToken();
      }
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    if (!(response && response.data)) {
      toastError({ message: MESSAGE.API_ERROR });
    }
    return response;
  },
  async (error) => {
    if (error.response && error.response?.status === 500) {
      const apiData = error.response?.data;
      if (apiData?.success === false && apiData?.error?.message) {
        // toastError({message: apiData?.error?.message || MESSAGE.API_ERROR})
      }
    }
    if (error.response && error.response.status === 401) {
      removeAllCookies();
      redirectToLogin();
    }
    return Promise.reject(error);
  },
);

export default api;
